<template>
  <!-- 保养录入弹窗 -->
  <el-dialog :title="$t('carOrder.carShare.tit_maintain')" :visible="visible" center class="carInfo" :before-close="cancelBut" append-to-body width="600px">
    <div v-loading="addloading">
      <el-form ref="form2" :model="form2">
        <el-form-item :label="$t('carOrder.carShare.label_car_number')+'：'" class="iptarea">
          <span>{{ form2.license }}</span>
        </el-form-item>
        <el-form-item :label="$t('carOrder.carShare.label_car_brand')+'：'">
          <span>{{ form2.car_model }}</span>
        </el-form-item>
        <el-form-item :label="$t('carOrder.cars.label_leijibaoyang')+'：'" class="iptarea">
          <span>{{ form2.total_mileage || 0 }}{{ $t('carOrder.carMileage.txt_km') }}</span>
        </el-form-item>
        <el-form-item :label="$t('carOrder.cars.label_shangcibaoyang')+'：'" class="iptarea">
          <span>{{ form2.last_maintain_mileage || 0 }}{{ $t('carOrder.carMileage.txt_km') }}</span>
        </el-form-item>
        <el-form-item :label="$t('carOrder.carShare.label_travel_km')+'：'" class="iptarea">
          <span>{{ form2.mileage || 0 }}{{ $t('carOrder.carMileage.txt_km') }}</span>
        </el-form-item>
        <el-form-item :label="$t('carOrder.cars.label_shijibaoyang')+'：'">
          <el-input v-model="form2.maintain_mileage" :placeholder="$t('carOrder.cars.tip_shijibaoyang')" style="width: 194px;" /> {{ $t('carOrder.carMileage.txt_km') }}
        </el-form-item>
        <el-form-item :label="$t('carOrder.carMaintenance.label_date')+'：'">
          <el-date-picker v-model="form2.date" type="date" :placeholder="$t('carOrder.carMaintenance.tip_date')" style="width: 194px;" value-format="yyyy-MM-dd" />
        </el-form-item>
        <el-form-item :label="$t('carOrder.carMaintenance.label_info')+'：'" class="iptarea">
          <el-input v-model="form2.detail_info" type="textarea" :placeholder="$t('carOrder.carMaintenance.tip_info')" style="width: 300px;" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align:center;">
        <el-button type="primary" @click="saveBtn2(form2.id)">{{ $t('allOrders.btn_modify') }}</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import {
  detailCarLicense,
  getMaintainUpdate // 保养详情修改
} from '@/api/car'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    orderid: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      addloading: false,
      form2: {
        id: undefined,
        license: undefined, // 车牌号
        car_id: undefined, // 车型id
        car_model: undefined, // 车型
        total_mileage: undefined, // 累计行驶公里
        last_maintain_mileage: undefined, // 上次实际保养公里数
        mileage: undefined, // 行驶公里
        maintain_mileage: '', // 实际保养公里数
        date: undefined, // 保养日期
        detail_info: undefined, // 保养详情
        is_maintain: 1
      }
    }
  },
  created() {
    this.maintain()
  },
  methods: {
    maintain() {
      this.addloading = true
      let _query = { license_id: this.orderid }
      detailCarLicense({ data: _query }).then(res => {
        this.form2 = res.data
        this.addloading = false
      })
    },
    saveBtn2(id) {
      let testnum = /^((([1-9]+(\d+)?)(\.\d+)?)|(0\.\d+))$/
      if (this.form2.maintain_mileage == '' || this.form2.maintain_mileage == undefined) {
        this.$message({
          message: this.$t('carOrder.cars.tip_shijibaoyang'),
          type: 'error'
        })
        return false
      } else if (!testnum.test(this.form2.maintain_mileage)) {
        this.$message({
          message: this.$t('carOrder.cars.tip_correct_shijibaoyang'),
          type: 'error'
        })
        return false
      }
      const _query = this.form2
      this.addloading = true
      getMaintainUpdate({ data: _query }).then(
        response => {
          this.addloading = false
          this.$message({
            message: this.$t('allOrders.tip_save_suc'),
            type: 'success'
          })
          setTimeout(() => {
            this.cancelBut()
            this.$emit('fresh')
          }, 2 * 1000)
        },
        reason => {
          this.addloading = false
        }
      )
    },
    /** 关闭弹窗/取消 */
    cancelBut() {
      this.$emit('cancelBut')
    }
  }
}
</script>
